import React, { useContext, useEffect, useState } from "react";
import Application from "../../StateContext/Application";
import { useLanguage } from "../../../../lang/langcontext/LanguageContext";
import GooglePagination from '../../styles/GooglePagination';
import { formatDateTime, formatDate } from '../../../../utils/DateFormat';

const LogReport = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const statecalls = useContext(Application);
  const { GetLogReports } = statecalls;
  const [technicalInwards, setTechnicalInwards] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const billsPerPage = 10;
  const totalPages = Math.ceil(filteredBills.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  // const currentBills = filteredBills.slice(indexOfFirstBill, indexOfLastBill);
  const sortedBills = Array.isArray(filteredBills)
    ? filteredBills
        .slice() // ✅ prevent state mutation
        .sort(
          (a, b) => new Date(b.ActionTimestamp) - new Date(a.ActionTimestamp),
        )
    : [];
  const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);
  const GetLogReportData = async () => {
    try {
      const data = await GetLogReports();
      setTechnicalInwards(data);
      setFilteredBills(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    GetLogReportData();
  }, []);

  useEffect(() => {
    const term = searchTerm.toLowerCase();
    const filtered = technicalInwards.filter((bill) =>
      Object.values(bill).some((val) =>
        (val || "").toString().toLowerCase().includes(term),
      ),
    );
    setFilteredBills(filtered);
    setCurrentPage(1);
  }, [searchTerm, technicalInwards]);

  return (
    <div
      className="col-12"
      style={{
        backgroundColor: "#EFF3F8",
        height: "89vh",
        overflowX: "scroll",
        overflowY: "scroll",
      }}
    >
      <div className="col-11 m-auto">
        <div className="col-12">
          <div
            className="col-12 px-4 mb-4 mt-3"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* <h4 style={{ margin: "10px 0px" }}></h4> */}
            <h5 className="my-auto fw-bold">
              <img
                src="/GR-Approval64.png"
                alt="Technical Approval"
                style={{ width: "24px", height: "24px" }}
                className="my-auto me-1"
              />
              <span className="my-auto">{t("Log Report")}</span>
            </h5>
            {/* <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)}
                            value={searchTerm}
                            style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} /> */}

            <div
              style={{
                position: "relative",
                width: "250px",
                marginRight: "10px",
              }}
            >
              <img
                src="/Search32.png"
                alt="Search Icon"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "10px",
                  transform: "translateY(-50%)",
                  width: "16px",
                  height: "16px",
                  opacity: 0.6,
                }}
              />
              <input
                type="text"
                placeholder={t("Search Here")}
                onChange={(e) => setSearchTerm(e.target.value)}
                value={searchTerm}
                style={{
                  width: "100%",
                  padding: "8px 12px 8px 32px", // left padding makes space for icon
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  backgroundColor: "#f1f6fc",
                  fontSize: "18px",
                  color: "#333",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                  outline: "none",
                }}
              />
            </div>
          </div>

          <div className="col-12 pb-5">
            <div
              className="col-12 mb-3"
              style={{
                backgroundColor: "white",
                padding: "40px 40px",
                boxShadow: "0px 0px 5px 1px #E4E8EC",
                borderRadius: "20px",
              }}
            >
              <div
  className="col-12 tableDesign"
  style={{
    background: "#2C78DB",
    overflowX: "auto",
    overflowY: "hidden",
    width: "100%",
    borderRadius: "5px",
  }}
>
  <table
    className="m-0 p-0"
    style={{
      width: "100%",
      minWidth: "1200px",
      borderCollapse: "collapse",
      tableLayout: "fixed",
    }}
  >
                  <thead>
                    <tr
                      style={{
                        color: "white",
                        border: "none",
                        height: "3rem",
                        fontSize: "18px",
                      }}
                    >
                      <th style={{ width: "4%" }}>{t("Sr.no.")}</th>
                      <th style={{ width: "15%" }}>{t("Action")}</th>
                      <th style={{ width: "12%" }}>{t("Entity ID")}</th>
                      <th style={{ width: "10%" }}>{t("Entity Type")}</th>
                      <th style={{ width: "15%" }}>{t("Performed By")}</th>
                      <th style={{ width: "15%" }}>{t("Role")}</th>
                      <th style={{ width: "15%" }}>{t("Date")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentBills?.length === 0 ? (
                      <tr>
                        <td
                          colSpan="10"
                          style={{
                            textAlign: "center",
                            padding: "20px",
                            backgroundColor: "#f9f9f9",
                          }}
                        >
                          {t("No data available")}
                        </td>
                      </tr>
                    ) : (
                      currentBills.map((e, index) => {
                        const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                        return (
                          <tr
                            style={{
                              backgroundColor: bgColor,
                              fontSize: "18px",
                              fontWeight: "400",
                            }}
                            key={index}
                          >
                            <td style={{ padding: "8px 8px" }}>
                              {(currentPage - 1) * billsPerPage + index + 1}
                            </td>
                            <td style={{ padding: "8px 8px" }}>
                              {e.ActionType}
                            </td>
                            <td style={{
    padding: "8px 8px",
    whiteSpace: "normal",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
  }}>{e.EntityID}</td>
                            <td style={{ padding: "8px 8px" }}>
                              {e.EntityType}
                            </td>
                            <td style={{ padding: "8px 8px" }}>
                              {e.PerformedBy}
                            </td>
                            <td style={{ padding: "8px 8px" }}>{e.Role}</td>
                            <td style={{ padding: "8px 8px" }}>
                              
                                {formatDateTime(e.ActionTimestamp)}
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>

              <div className="col-12 mt-4">
                <div className="row">

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      height: "4rem",
                      alignItems: "center",
                    }}
                    className="mt-3"
                  >
                    <div>
                      <p className="text-gray-600" style={{ fontSize: "18px" }}>
                        {t("Showing")} {indexOfFirstBill + 1} {t("to")}{" "}
                        {Math.min(indexOfLastBill, filteredBills.length)}{" "}
                        {t("of")} {technicalInwards.length} {t("entries")}
                      </p>
                    </div>

                    <div style={{ display: "flex", alignItems: "center" }}>
                      <GooglePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogReport;
